import { useCharlieUser } from 'hooks/useCharlieUser'
import { insightsAssessmentViewedEvent } from 'utils/analytics/amplitudeEvents'

import { Company } from './assets/icons/Company'
import { useMenuGroupAssessment } from './hooks/useMenuGroupAssessment'
import { MenuGroup } from './MenuGroup'

export const MenuGroupAssessment = () => {
  const { sidebarItems: sidebarAssessmentItem } = useMenuGroupAssessment()
  const charlieUser = useCharlieUser()

  if (!sidebarAssessmentItem) {
    return null
  }
  return (
    <MenuGroup
      key={sidebarAssessmentItem.text}
      {...sidebarAssessmentItem}
      icon={<Company />}
      onClick={() =>
        insightsAssessmentViewedEvent(
          { topic: sidebarAssessmentItem.text },
          charlieUser
        )
      }
    />
  )
}
